import React, {useEffect, useState} from 'react';
import {getSheetByNumber} from '../../utility/FetchAPI';
import {SheetTable} from '../category/sheetPage/SheetTable';
import {useNavigate} from 'react-router-dom';
import {WbIcon} from '@workbench/react';
import {Icon} from '@workbench/core';

const SearchResultCard = ({sheetNumber, prioritySheet, t, i18n}) => {
    const [productSheet, setProductSheet] = useState(null);
    const [, setLinkedFluidCount] = useState(0);
    const [, setUnlinkedFluidCount] = useState(0);
    const [showMore, setShowMore] = useState(false);
    const agreeAll = (sheetNumber) => {
        const path = `/sheet/${sheetNumber}/${i18n.language}`;
        window.open(path, '_blank');
    };
    useNavigate();

    useEffect(() => {
        if (!sheetNumber) return;

        const fetchData = async () => {
            try {
                const response = await getSheetByNumber("DTFR_" + sheetNumber);
                setProductSheet(response.data);
            } catch (err) {
                console.error("Failed to fetch sheet:", err);
            }
        };

        fetchData();
    }, [sheetNumber]);

    if (!productSheet) {
        return <div>Loading...</div>; // or null or skeleton loader
    }

    const langKey = `additionalInfo${i18n.language.charAt(0).toUpperCase() + i18n.language.slice(1)}`;
    const description = productSheet?.[langKey] || '';

    return (
        <div className="wb-padding-s searchCard" style={{width: "100%"}}>
            <wb-card interactive variant="dark-grey" className="hydrated" style={{border: "none"}}>
                <div className="totalcontentRow">
                    <div className="left-column">
                        <div className="text wb-type-hint firstColumnHeader">{t("Sheet")}</div>
                        <div className="wb-type-heading-m firstColumnText">
                            {productSheet?.sheetNumber}
                        </div>
                    </div>
                    <div className="right-column">
                        <div className="cardbox">
                            <div className="extrabox">
                                <div className="wb-type-hint secondColumnHeader">
                                    {t("Description")}
                                </div>
                                <div
                                    className="wb-type-label secondColumnText"
                                    dangerouslySetInnerHTML={{
                                        __html: description || "—",
                                    }}
                                ></div>
                            </div>
                            <div className='wb-button wb-button--primary wb-button--small MBBeVoIconCard__button-anchor'
                                 style={{height: "100%", marginTop: "2%"}}>
                                <button
                                    onClick={() => agreeAll(productSheet?.sheetNumber)}
                                    type='button'
                                    className=""
                                    style={{margin: "5px"}}
                                >
                                    <WbIcon
                                        className='MBBeVoIconCard__button-icon'
                                        name={Icon.ChevronRight}
                                    />
                                    <span style={{fontSize: "small", fontWeight: "bold"}}>{t("LearnMore")}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                {prioritySheet && (
                    <div>
                        <SheetTable
                            sheet={productSheet}
                            language={`${i18n.language}`}
                            showMore={showMore}
                            setLinkedFluidCount={setLinkedFluidCount}
                            setUnlinkedFluidCount={setUnlinkedFluidCount}
                            setShowMore={setShowMore}
                        />
                    </div>
                )}
            </wb-card>
        </div>
    );
};

export default SearchResultCard;
